// src/components/Accounts/InvitationFormModal.jsx
import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Row,
  Col,
  Label,
  Input,
  FormFeedback,
  Button,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";

/**
 * Composant : Modal + Formulaire d'invitation utilisateur
 */
const InvitationFormModal = ({ isOpen, toggle, roles, onSubmit }) => {
  const validation = useFormik({
    initialValues: {
    
      email: "",
      role_id: "",
    
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Adresse email invalide")
        .required("Veuillez saisir l'email"),
      role_id: Yup.number().required("Veuillez sélectionner le rôle"),
     
    }),
    onSubmit: (values) => {
      onSubmit(values);
      validation.resetForm();
    },
  });

  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop="static">
      <ModalHeader toggle={toggle} tag="h4">
        Inviter un utilisateur
      </ModalHeader>

      <ModalBody>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
          }}
        >
          <Row>
            <Col xs="12">
              <div className="mb-3">
                <Label>Email</Label>
                <Input
                  name="email"
                  type="email"
                  placeholder="Email"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.email}
                  invalid={
                    validation.touched.email && validation.errors.email
                      ? true
                      : false
                  }
                />
                <FormFeedback>{validation.errors.email}</FormFeedback>
              </div>

              <div className="mb-3">
                <Label>Profil</Label>
                <Input
                  name="role_id"
                  type="select"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.role_id}
                  invalid={
                    validation.touched.role_id && validation.errors.role_id
                      ? true
                      : false
                  }
                >
                  <option value="">-- Sélectionner --</option>
                  {roles.map((role) => (
                    <option key={role.id} value={role.id}>
                      {role.name}
                    </option>
                  ))}
                </Input>
                <FormFeedback>{validation.errors.role_id}</FormFeedback>
              </div>

              

              
            </Col>
          </Row>

          <div className="text-end">
            <Button color="primary" type="submit">
              Envoyer l’invitation
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default InvitationFormModal;
